// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__00vM_"};